import { cn } from "@/lib/util";

/**
 * Detailed inspector for a single firing. Presentational.
 */
export function FiringDetail({ firing }) {
  if (!firing) {
    return (
      <div className="h-full flex items-center justify-center text-xs text-muted-foreground font-mono">
        Selecciona un disparo en la cronología para inspeccionar la instantánea exacta del evento.
      </div>
    );
  }
  return (
    <div className="space-y-4" data-testid="firing-detail">
      <Section title="Disparado el" value={new Date(firing.fired_at).toLocaleString()} mono />
      <Section title="Asunto" value={firing.subject} />
      <Section
        title="Destinatarios"
        value={firing.recipients?.join(", ") || "—"}
        mono
        muted
      />
      <div>
        <div className="overline mb-1">Vista previa del cuerpo</div>
        <div className="text-xs whitespace-pre-wrap border border-border p-3 bg-background/50 font-mono max-h-52 overflow-y-auto">
          {firing.body_preview || "—"}
        </div>
      </div>
      {firing.error && (
        <div>
          <div className="overline mb-1 text-sev-critical">Error</div>
          <div className="text-xs text-sev-critical font-mono">{firing.error}</div>
        </div>
      )}
      <div>
        <div className="overline mb-1">Instantánea del evento</div>
        <pre className="text-[10px] font-mono border border-border p-3 bg-background overflow-x-auto max-h-60">
{JSON.stringify(firing.event_snapshot, null, 2)}
        </pre>
      </div>
      <div className="grid grid-cols-2 gap-2 pt-3 border-t border-border">
        <MetaRow label="ID de regla" value={firing.rule_id} mono />
        <MetaRow label="Tipo de evento" value={firing.event_kind} mono />
        <MetaRow label="Cliente" value={firing.client_name || "—"} />
        <MetaRow label="Adjuntos" value={(firing.attachments || []).join(", ") || "—"} />
      </div>
    </div>
  );
}

function Section({ title, value, mono, muted }) {
  return (
    <div>
      <div className="overline mb-1">{title}</div>
      <div className={cn(mono && "font-mono text-sm", !mono && "text-sm", muted && "text-muted-foreground text-xs")}>
        {value}
      </div>
    </div>
  );
}

function MetaRow({ label, value, mono }) {
  return (
    <div className="text-xs">
      <div className="font-mono text-[9px] tracking-widest uppercase text-muted-foreground">{label}</div>
      <div className={cn("mt-0.5 truncate", mono && "font-mono text-[11px]")}>{value}</div>
    </div>
  );
}
